import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { JoinSessionVM } from '../models/JoinSessionVM';
import { CommsService } from '../../services/comms.service';
import { JoinSessionResponseVM } from '../models/JoinSessionResponseVM';
import { SessionType } from '../models/SessionType';
import { SessionStatus } from '../models/SessionStatus';

@Component({
  selector: 'device-setup',
  templateUrl: './device-setup.component.html'
})

export class DeviceSetupComponent implements OnInit {

  model: JoinSessionVM = new JoinSessionVM();
  status: SessionStatus | null;
  statusMessage: string;
  isConnecting: boolean = false;
  newDeviceSetupStage: number = 0;

  constructor(private router: Router, private route: ActivatedRoute, private commsService: CommsService) {

  }

  ngOnInit(): void {
  }

  stepChanged(stage: number) {
    this.newDeviceSetupStage = stage;

    if (this.newDeviceSetupStage == 0) {
    }

    if (this.newDeviceSetupStage == 1) {
    }

    if (this.newDeviceSetupStage == 2) {
    }

    if (this.newDeviceSetupStage == 3) {
    }

    if (this.newDeviceSetupStage == 4) {
    }

    if (this.newDeviceSetupStage == 5) {
    }
  }
}

